import MoreOptionsModal from '@/components/ContentMoreOptions/Modal/MoreOptionsModal';
import EmptyList from '@/components/EmptyList';
import Loader from '@/components/Loader';
import { Pagination } from '@/components/Pagination';
import Constants from '@/Constants';
import { ApplicationState } from '@/store';
import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import '../styles.scss';
import { CategoryCard } from './CategoryCard';
import './styles.scss';

interface CategoryListProps {
    currentPage: number;
    showOnlyInactive: boolean;
    registersPerPage: number;
    onPageChange: (page: number) => void;
    onUpdateCategoryList: () => void;
    handleCreateNewCategory: (event: React.MouseEvent<Element, MouseEvent>) => void;
}

const CategoryList: React.FC<CategoryListProps> = ({
    currentPage,
    registersPerPage,
    handleCreateNewCategory,
    onPageChange,
    showOnlyInactive,
    onUpdateCategoryList,
}: CategoryListProps) => {
    const { strings, categories, isLoading, totalCountOfRegisters } = useSelector((state: ApplicationState) => ({
        strings: state.locale.data,
        categories: state.categories.data.categories || [],
        isLoading: state.categories.loading,
        totalCountOfRegisters: state.categories.data.categoriesTotalCountOfRegisters,
    }));

    const isEmptyList = useMemo(() => {
        return !!!categories || categories.length === 0;
    }, [categories]);

    const emptyMessage = useMemo(
        () => (showOnlyInactive ? strings.CATEGORY_MANAGEMENT_INACTIVE_LIST_EMPTY : strings.CATEGORY_MANAGEMENT_LIST_EMPTY),
        [showOnlyInactive],
    );

    const showBigLoaded = useMemo(() => {
        return isLoading && isEmptyList;
    }, [isEmptyList, isLoading]);

    return (
        <div className="category-list-container">
            <MoreOptionsModal modalId={Constants.modal.CONFIRMATION_MODAL} />
            <MoreOptionsModal modalId={Constants.modal.ACTIVATE_INACTIVATE_RESULT_MODAL} />
            <MoreOptionsModal modalId={Constants.modal.COULD_NOT_INACTIVATE_CATEGORY_MODAL} />
            <div className="list-container">
                {showBigLoaded ? (
                    <Loader />
                ) : isEmptyList ? (
                    <EmptyList
                        buttonTitle={strings.CATEGORY_MANAGEMENT_ADD_NEW_CATEGORY}
                        handleNewList={!showOnlyInactive ? handleCreateNewCategory : undefined}
                        icon={Constants.icons.BALLOT}
                        title={emptyMessage}
                    />
                ) : (
                    <ul className="list-content">
                        <div className="list-content-header">
                            <span>{strings.TITLE}</span>
                        </div>

                        {categories.map((category) => (
                            <CategoryCard category={category as any} key={category.id} onUpdateCategoryList={onUpdateCategoryList} />
                        ))}

                        <div className="pagination-container">
                            <Pagination
                                currentPage={currentPage}
                                onPageChange={onPageChange}
                                registersPerPage={registersPerPage}
                                totalCountOfRegisters={totalCountOfRegisters}
                            />
                        </div>
                    </ul>
                )}
            </div>
        </div>
    );
};

export { CategoryList };
